import { useEffect, useState } from 'react'
import useHttp from 'hooks/useHttp'
import { useWeb3React } from '@web3-react/core'
import { Chain, Payment } from '../types'

export interface IGO {
  Chain: Chain
  Payment: Payment
  chain_id: number
  finished_time: number
  id: number
  list_image_after: string
  list_image_before: string
  list_image_in: string
  payment_id: number
  per_account_token_amount: string
  sale_begin_time: number
  sale_end_time: number
  sale_token_amount: string
  sale_contract: string
  social: string
  social_: {
    name: string
    url: string
  }[]
  title: string
  token_name: string
  token_symbol: string
  token_logo: string
  unit_price: number
  desc: string
  website: string
}

// status: 0-to be opend  1-onging  2-closed  3-all
export function useIGOList(status: number) {
  const $http = useHttp()
  const [list, setList] = useState<IGO[]>([])
  const [loading, setLoading] = useState(false)
  const { chainId } = useWeb3React()

  useEffect(() => {
    let unmount = false
    const getList = async () => {
      const params = {
        page: 1,
        limit: 100,
        status,
        chain_id: chainId,
      }
      setLoading(true)
      const { data, status: statusCode } = await $http.get(`/igo/project/list`, { params })
      if (statusCode === 200 && !unmount) {
        setLoading(false)
        setList(data.items || [])
      }
    }
    getList()
    return () => {
      unmount = true
    }
  }, [status, $http, chainId])

  return {
    list,
    loading,
  }
}
